const WhatsApp = () => {
  return (
    <div>
      <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1_239)">
          <path
            d="M0.998489 9.38759C0.998048 10.9804 1.41423 12.5357 2.2056 13.9065L0.922806 18.5902L5.71599 17.3334C7.04172 18.0551 8.52711 18.4333 10.0366 18.4334H10.0405C15.0235 18.4334 19.0798 14.3786 19.0819 9.39471C19.0829 6.97968 18.1432 4.70873 16.436 3.0002C14.7291 1.29181 12.4589 0.350467 10.0402 0.349365C5.05659 0.349365 1.00062 4.40394 0.998563 9.38759"
            fill="url(#paint0_linear_1_239)"
          />
          <path
            d="M0.673303 9.38365C0.672789 11.0338 1.10389 12.6447 1.92348 14.0646L0.594681 18.9162L5.55973 17.6143C6.92777 18.3602 8.46804 18.7535 10.0353 18.7541H10.0394C15.2011 18.7541 19.4031 14.5534 19.4053 9.39114C19.4062 6.88933 18.4328 4.53675 16.6646 2.76701C14.8961 0.997483 12.5448 0.0222689 10.0394 0.0212402C4.87675 0.0212402 0.675361 4.2213 0.673303 9.38365ZM3.6301 13.82L3.44471 13.5257C2.66539 12.2866 2.25406 10.8546 2.25465 9.38424C2.25634 5.09343 5.74836 1.60251 10.0423 1.60251C12.1218 1.60339 14.076 2.41401 15.5459 3.88477C17.0157 5.35567 17.8245 7.31095 17.824 9.39056C17.8221 13.6814 14.33 17.1727 10.0394 17.1727H10.0363C8.63924 17.172 7.26908 16.7968 6.07416 16.0878L5.7898 15.9192L2.84343 16.6917L3.6301 13.82V13.82Z"
            fill="url(#paint1_linear_1_239)"
          />
          <path
            d="M7.70038 5.4701C7.52506 5.08044 7.34055 5.07258 7.17383 5.06575C7.0373 5.05987 6.88123 5.06031 6.72531 5.06031C6.56924 5.06031 6.31566 5.11902 6.10133 5.35305C5.88677 5.5873 5.28218 6.15339 5.28218 7.30473C5.28218 8.45615 6.1208 9.56884 6.2377 9.72513C6.35476 9.88113 7.85667 12.3195 10.2353 13.2575C12.2122 14.037 12.6145 13.882 13.0436 13.8429C13.4727 13.804 14.4282 13.277 14.6231 12.7305C14.8182 12.1841 14.8182 11.7158 14.7597 11.6179C14.7012 11.5204 14.5452 11.4618 14.3111 11.3448C14.077 11.2278 12.9265 10.6616 12.712 10.5835C12.4975 10.5055 12.3415 10.4665 12.1854 10.7009C12.0293 10.9348 11.5812 11.4618 11.4446 11.6179C11.3081 11.7743 11.1715 11.7938 10.9376 11.6767C10.7034 11.5593 9.94972 11.3125 9.05555 10.5153C8.35985 9.89501 7.89017 9.12899 7.75365 8.89467C7.61713 8.66071 7.73903 8.53389 7.85637 8.41728C7.96152 8.31242 8.09048 8.14401 8.2076 8.00741C8.32429 7.87074 8.36323 7.77323 8.44127 7.61716C8.51938 7.46095 8.48028 7.32427 8.42187 7.20722C8.36323 7.09017 7.90847 5.9328 7.70038 5.4701Z"
            fill="white"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1_239"
            x1="908.878"
            y1="1824.43"
            x2="908.878"
            y2="0.349365"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1FAF38" />
            <stop offset="1" stop-color="#60D669" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1_239"
            x1="941.127"
            y1="1889.51"
            x2="941.127"
            y2="0.0212402"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#F9F9F9" />
            <stop offset="1" stop-color="white" />
          </linearGradient>
          <clipPath id="clip0_1_239">
            <rect
              width="18.8106"
              height="18.9576"
              fill="white"
              transform="translate(0.594681 0.0212402)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default WhatsApp;
